import { render } from "./DeptMenuTitle.vue?vue&type=template&id=e12209ea"
import script from "./DeptMenuTitle.vue?vue&type=script&lang=js"
export * from "./DeptMenuTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__